// ownership form
export const OWNERSHIP_FORM_REQUEST = 'OWNERSHIP_FORM_REQUEST'
export const OWNERSHIP_FORM_SUCCESS = 'OWNERSHIP_FORM_SUCCESS'
export const OWNERSHIP_FORM_ERROR = 'OWNERSHIP_FORM_ERROR'
export const SET_USER_ID = 'SET_USER_ID'
export const SET_FOLDER_ID = 'SET_FOLDER_ID'
export const SET_ROLE = 'SET_ROLE'

// update ownership
export const UPDATE_OWNERSHIP_REQUEST = 'UPDATE_OWNERSHIP_REQUEST'
export const UPDATE_OWNERSHIP_SUCCESS = 'UPDATE_OWNERSHIP_SUCCESS'
export const UPDATE_OWNERSHIP_ERROR = 'UPDATE_OWNERSHIP_ERROR'

// Memberships
export const FETCH_OWNERSHIPS_REQUEST = 'FETCH_OWNERSHIPS_REQUEST'
export const FETCH_OWNERSHIPS_SUCCESS = 'FETCH_OWNERSHIPS_SUCCESS'
export const FETCH_OWNERSHIPS_ERROR = 'FETCH_OWNERSHIPS_ERROR'
export const SET_OWNERSHIPS = 'SET_OWNERSHIPS'



// WEBPACK FOOTER //
// ./src/store/modules/ownerships/types.js